/**
 * useDraggableList
 * 
 * Hook genérico para gerenciar listas reordenáveis via Drag and Drop.
 * Suporta modo controlado (passando items e setItems).
 */
import { useState, useCallback } from 'react';

export function useDraggableList<T>(
    items: T[],
    setItems: React.Dispatch<React.SetStateAction<T[]>>,
    onChange?: () => void
) {
    const [draggedIndex, setDraggedIndex] = useState<number | null>(null);

    const handleDragStart = useCallback((index: number) => {
        setDraggedIndex(index);
    }, []);

    const handleDragOver = useCallback((e: React.DragEvent, index: number) => {
        e.preventDefault();

        if (draggedIndex === null || draggedIndex === index) return;

        setItems((prev: T[]) => {
            const newList = [...prev];
            const draggedItem = newList[draggedIndex];

            // Remove do índice antigo
            newList.splice(draggedIndex, 1);
            // Insere no novo índice
            newList.splice(index, 0, draggedItem);

            return newList;
        });

        // Atualiza o índice arrastado para ser o novo índice atual
        setDraggedIndex(index);

        if (onChange) {
            onChange();
        }
    }, [draggedIndex, setItems, onChange]);

    const handleDragEnd = useCallback(() => {
        setDraggedIndex(null);
    }, []);

    return {
        draggedIndex,
        handleDragStart,
        handleDragOver,
        handleDragEnd
    };
}
